import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

import { WebFacade } from '../store/web/web-facade.service';

@Injectable({ providedIn: 'root' })
export class RedirectService {
  webfacadeService = inject(WebFacade);
  platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);

  finalUrl = '';

  /**
   * Redirects to another portal with encrypted data from localStorage
   * @param targetUrl - The base URL of the target portal (e.g. https://portal-b.example/accept)
   * @param storageKey - The key used in localStorage (default: "web")
   * @param paramName - The query param name to send (default: "web")
   */
  redirectWithEncryptedData(
    targetUrl: string,
    storageKey: string,
    paramName: string,
    route?: string
  ): void {
    if (!this.isBrowser) {
      return;
    }

    const ENCRYPTED = localStorage.getItem(storageKey);
    if (!ENCRYPTED) {
      return;
    }

    if (route) {
      this.finalUrl = `${targetUrl}/${route}?${paramName}=${encodeURIComponent(ENCRYPTED)}`;
    } else if (!route) {
      this.finalUrl = `${targetUrl}?${paramName}=${encodeURIComponent(ENCRYPTED)}`;
    }

    this.webfacadeService.clearWebState();
    window.open(this.finalUrl, '_blank', 'noopener,noreferrer');
  }
}
